import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "py-sm-1 d-block" }
const _hoisted_7 = { class: "table-content" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import ItemFilter from "./ItemFilter.vue";
import { useVesselItemStore } from "@/stores/management/item-vessel";
import { hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListItemVessel',
  setup(__props) {

const linkAdd = {
  text: "Add Vessel Item",
  url: "/management/vessel-item/create",
};

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code" },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "ITEM NAME", value: "goods_name" },
  { text: "VESSEL", value: "vessel_name" },
  { text: "MAX QUANTITY", value: "quantity" },
  { text: "ROB", value: "rob" },
  { text: "ACTIONS", value: "action" },
];

const vesselItemStore = useVesselItemStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listVesselItems = ref<any>([]);
const isLoading = ref(false);

const loadDataVesselItems = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await vesselItemStore.dispatchGetList(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listVesselItems.value = await vesselItemStore.vesselItems.items;
    page.value = await vesselItemStore.vesselItems.page;
    limit.value = await vesselItemStore.vesselItems.pageSize;
    totalItems.value = await vesselItemStore.vesselItems.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataVesselItems();
};

const handleEdit = (item: any) => {
  router.push("/management/vessel-item/" + item);
};

const handleDelete = async (item: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${item.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await vesselItemStore.dispatchDelete(
          item.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataVesselItems();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataVesselItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0" }, "List Data Vessel Item", -1)),
        (linkAdd != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
                href: linkAdd?.url
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(linkAdd?.text), 1)
                ])
              ], 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ItemFilter, {
        link: linkAdd,
        onSearchByQuery: loadDataVesselItems
      }),
      _createElementVNode("div", _hoisted_7, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
              key: 1,
              headers: headers,
              items: listVesselItems.value,
              "show-index": "",
              "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
              "server-items-length": totalItems.value,
              "onUpdate:serverOptions": handleServerOptionsUpdate,
              "buttons-pagination": ""
            }, {
              "item-image": _withCtx((props) => [
                _createElementVNode("img", {
                  src: props.image_link,
                  alt: "image-link",
                  class: "image-item"
                }, null, 8, _hoisted_8)
              ]),
              "item-action": _withCtx((props) => [
                _createElementVNode("div", _hoisted_9, [
                  (_unref(hasAccess)('vessel_item_quantity-update'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info btn-sm text-white",
                        onClick: ($event: any) => (handleEdit(props.id))
                      }, " Edit ", 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_unref(hasAccess)('vessel_item_quantity-delete'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-danger btn-sm",
                        onClick: ($event: any) => (handleDelete(props))
                      }, " Delete ", 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["items", "server-options", "server-items-length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})